module.exports = __webpack_public_path__ + "static/img/jp4.b6d32c7f.png";